import { Carousel } from "../components/Carousel";
import HeroSection from "../components/Herosection";
import ServicesSection from "../components/services";
import AboutSection from "../components/AboutSection";
import ContactSection from "../components/Contactsection";

const Homepage = () => {
  return (
    <>
      <div>
        <HeroSection />
        <Carousel />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
      </div>
    </>
  );
};

export default Homepage;
